/* global I18n, $ */

document.addEventListener('DOMContentLoaded', function(){

    $dataRange = $('[data-range]');

    $dataRange.on('input', function(){
       const $that = $(this);
       const dataRangeId = $that.attr('data-range');
       const format = $that.attr('data-format') || 'raw';
       const value = $that.val();
       $(`[data-range-text="${dataRangeId}"]`)
           .text(`${I18n.t(`js.forms.range.${format}`, {value: value})}`);
    });

    $dataRange.trigger('input');
});